import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarMisSolicitudes } from "../services/mis-solicitudes-service";

/**
 * Carga las solicitudes del usuario actual (todas, no paginadas en MVP)
 * y el componente de "Última actividad" selecciona las 5 más recientes
 * por FechaUltimoEvento.
 *
 * Comparte la query key con `/solicitudes` para que un `invalidateQueries`
 * en cualquier mutation actualice también el dashboard.
 */
export const actividadRecienteQueryOptions = queryOptions({
  queryKey: qk.misSolicitudes,
  queryFn: listarMisSolicitudes,
  refetchInterval: 30_000,
  staleTime: 0,
});

export function useActividadReciente() {
  return useQuery(actividadRecienteQueryOptions);
}
